/* Olivia's Jewelry — CRO scripts
   Sticky ATC bar + sticky desktop header visibility only. No tracking. */
(function () {
  'use strict';

  function init() {
    var atc = document.querySelector('[data-add-to-cart]');
    var bars = document.querySelectorAll('[data-olivia-sticky]');

    // Proxy CTAs (sticky bar, final CTA) click the real add-to-cart button so we
    // never duplicate the product form, which would break variant selection.
    // Attached independently of the sticky bar so a page can use one without the other.
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-olivia-sticky-cta]'),
      function (btn) {
        btn.addEventListener('click', function (e) {
          var target = document.querySelector('[data-add-to-cart]');
          if (!target) return;
          e.preventDefault();
          target.click();
        });
      }
    );

    if (!bars.length || !atc || !('IntersectionObserver' in window)) return;

    var show = function (on) {
      Array.prototype.forEach.call(bars, function (bar) {
        bar.classList.toggle('is-visible', on);
      });
    };

    // Show the bars once the real ATC has scrolled up out of view.
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    observer.observe(atc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
